<template>
  <div class="container">
    <div class="row h-50">
      <div
        v-if="loading"
        class="row d-flex justify-content-center align-middle my-4"
      >
        <h3>Loading magical things :)</h3>
      </div>
      <div class="col-8 offset-2 my-4" v-else>
        <h2 class="message">Enter a Vehicle ID to Lookup Installed Keys</h2>
        <h3 class="text-danger">Environment {{ selected }}</h3>
        <p>Please only a 16 digit alphanumeric value</p>
        <div class="row">
          <label class="message" for="vehicleID">Vehicle ID</label>
          <input
            class="form-control my-2"
            id="vehicleID"
            v-model="vehicleID"
            type="text"
            maxlength="16"
            name="vehicleID"
          />
        </div>
        <div class="row">
          <label class="message" for="selected">Select an environment</label>
          <select
            class="form-select my-2"
            aria-label="Select an environment"
            v-model="selected"
          >
            <option selected>Select an environment</option>
            <option value="qa">QA</option>
            <option value="stgTwo">STG</option>
            <option value="prod">PROD</option>
          </select>
        </div>
        <div class="py-3" style="text-align: center">
          <button class="ty-button" v-on:click="requestLookupVehicle">
            Lookup Vehicle
          </button>
        </div>
        <div v-if="vehicleData != null">
          <table class="table">
            <thead>
              <tr>
                <th scope="col">Key Info ID</th>
                <th scope="col">State</th>
                <th scope="col">OwnerShip</th>
              </tr>
            </thead>
            <tbody>
              <tr :key="item.key_info_id" v-for="item in vehicleData">
                <th scope="row">{{ item.key_info_id }}</th>
                <td>{{ item.state }}</td>
                <td>{{ item.ownership }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "DKLookupInstalled",
  data: () => {
    return {
      vehicleID: "",
      error: null,
      loading: false,
      vehicleData: null,
      noVehicleData: false,
      qaURL:
        "https://gvw9p1ejk4.execute-api.us-west-2.amazonaws.com/dev/dkinfo",
      stgTwoURL:
        "https://iawtvi82bi.execute-api.us-west-2.amazonaws.com/staging/dkinfostgtwob",
      prodURL:
        "https://ojjp1mt3ef.execute-api.us-west-2.amazonaws.com/staging/dkinstalledkeys",
      selected: "prod",
    };
  },
  methods: {
    generateENVURL: function () {
      if (this.selected === "stgTwo") {
        return this.stgTwoURL;
      }
      if (this.selected === "prod") {
        return this.prodURL;
      }
      if (this.selected === "qa") {
        return this.qaURL;
      } else {
        return this.stgTwoURL;
      }
    },
    requestLookupVehicle: async function () {
      this.error = null;
      this.vehicleData = null;
      if (!this.vehicleID) {
        alert("Please input vehicleId");
        return;
      }
      console.log("Selected Environment: ", this.generateENVURL());
      const ENV_URL = this.generateENVURL();
      this.loading = true;

      const data = JSON.stringify({
        vehicle_id: this.vehicleID,
      });

      const config = {
        method: "post",
        url: ENV_URL,
        headers: {
          "Content-Type": "application/json",
        },
        data: data,
      };
      this.axios(config)
        .then((response) => {
          console.log("DK Installed Response", response);
          if (!response.data.results) {
            this.loading = false;
            this.vehicleData = null;
            alert("This vehicle id has no installed keys.");
          } else {
            this.vehicleData = response.data.results;
            this.loading = false;
          }
        })
        .catch((error) => {
          this.loading = false;
          console.log(error);
          this.error =
            error.response.data != null ? error.response.data : error.response;
          alert(`Well that was unexpected.  ${this.error}`);
        });
    },
  },
};
</script>

<style>
.ty-button {
  background: #d92429;
  border-radius: 80px;
  width: 320px;
  height: 56px;
  font-family: ToyotaType-Semibold;
  font-size: 20px;
  color: #ffffff;
  letter-spacing: 0.73px;
  text-align: center;
}
</style>
